import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'richText'
})
export class LMRichTextPipe  implements PipeTransform {

  constructor(protected _sanitizer: DomSanitizer) {

  }

  public transform(triggerValue: boolean, value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value.replace(/&nbsp;/g, ' '));
  }
}
